

(function blocReassurance () {
   const isCompExists = GlobalSite.checkDependency("GlobalSite.isCompExists");
   const compName = "bloc-reassurance";
   const logFactory = GlobalSite.checkDependency("GlobalSite.logFactory");
   const Log = logFactory(`${compName}.js`);

    if (!isCompExists(compName, Log)) {
      return;
    }

    $(() => {
    })

    })()